/**
 * In-memory store for the service account token.
 * Set by AuthContext when the token is fetched; read by apiFetch for all API requests.
 */

let currentUserToken = null;
let currentServiceToken = null;

export const serviceTokenStore = {
  setToken(token) {
    currentServiceToken = token ?? null;
  },

  getToken() {
    return currentServiceToken;
  },
  revokeToken() {
    currentServiceToken = null;
  },
};

export const userTokenStore = {
  setToken(token) {
    currentUserToken = token ?? null;
  },

  getToken() {
    return currentUserToken;
  },
  revokeToken() {
    currentUserToken = null;
  },
}
